(function () {
  'use strict';

  // <onevine-light data-mode="rays|candle">: real-time light rendered with a
  // single WebGL fragment shader. "rays" is window light with dust drifting
  // through the beams; "candle" is a low flickering glow with rising embers.
  // Light is soft, so it is drawn small and stretched: a fixed pixel budget
  // (far below the screen's resolution) at 30 frames a second, only while on
  // screen. The budget drops further if frames run slow. Reduced motion gets
  // one still frame; without WebGL the section's own backdrop remains.
  if (!window.customElements || customElements.get('onevine-light')) return;

  var VERTEX = 'attribute vec2 a;void main(){gl_Position=vec4(a,0.0,1.0);}';
  var FRAGMENT = [
    '#ifdef GL_FRAGMENT_PRECISION_HIGH',
    'precision highp float;',
    '#else',
    'precision mediump float;',
    '#endif',
    'uniform vec2 uRes;uniform float uTime;uniform vec2 uPointer;uniform float uMode;uniform float uFade;',
    'uniform vec3 uGold;uniform vec3 uBlood;uniform vec3 uInk;',
    // Bound the multiply even on devices limited to mediump fragment floats.
    'float hash(vec2 p){p=fract(mod(p,32.0)*vec2(123.34,456.21));p+=dot(p,p+45.32);return fract(p.x*p.y);}',
    'float noise(vec2 p){vec2 i=floor(p);vec2 f=fract(p);vec2 u=f*f*(3.0-2.0*f);',
    '  return mix(mix(hash(i),hash(i+vec2(1.0,0.0)),u.x),mix(hash(i+vec2(0.0,1.0)),hash(i+vec2(1.0,1.0)),u.x),u.y);}',
    'float fbm(vec2 p){float v=0.0;float a=0.5;for(int i=0;i<3;i++){v+=a*noise(p);p=p*2.03+vec2(17.0,9.0);a*=0.5;}return v;}',
    // One layer of motes: a jittered grid, each cell holding at most one soft point.
    'float motes(vec2 p,float scale,vec2 drift,float t,float density){',
    '  vec2 g=p*scale+drift*t;vec2 id=floor(g);vec2 f=fract(g)-0.5;float h=hash(id);',
    '  vec2 o=vec2(hash(id+3.1),hash(id+7.7))-0.5;o+=0.16*vec2(sin(t*0.6+h*30.0),cos(t*0.5+h*20.0));',
    '  float size=mix(0.03,0.09,hash(id+1.9));float s=1.0-smoothstep(0.0,size,length(f-o*0.75));',
    '  float twinkle=0.55+0.45*sin(t*(0.8+h*2.0)+h*60.0);return s*step(1.0-density,h)*twinkle;}',
    'void main(){',
    '  vec2 uv=gl_FragCoord.xy/uRes;float aspect=uRes.x/uRes.y;',
    '  vec2 p=vec2((uv.x-0.5)*aspect,uv.y-0.5);float t=mod(uTime,600.0);',
    '  vec2 pt=(uPointer-0.5)*vec2(aspect,1.0);vec3 col=uInk;',
    '  if(uMode<0.5){',
    '    vec2 src=vec2(0.30*aspect+pt.x*0.16,0.86+pt.y*0.05);vec2 d=p-src;float dist=length(d);',
    '    float ang=atan(d.x,-d.y);float cone=1.0-smoothstep(0.08,0.7,abs(ang+0.40));',
    '    float r1=noise(vec2(ang*7.0+11.0,t*0.05));float r2=noise(vec2(ang*19.0-3.0,t*0.08+5.0));',
    '    float rays=pow(r1,2.2)*0.95+pow(r2,3.2)*0.75;',
    '    float haze=fbm(p*1.7+vec2(t*0.012,-t*0.008));',
    '    float beam=rays*cone*exp(-dist*0.8)*(0.5+0.7*haze);',
    '    col+=uGold*beam*0.62;col+=uGold*0.28*exp(-dist*2.4);',
    '    col+=uBlood*0.42*(1.0-smoothstep(-0.55,0.5,p.y))*(1.0-smoothstep(-0.2,0.9*aspect,p.x))*(0.6+0.4*haze);',
    '    float m=motes(p,20.0,vec2(0.10,-0.16),t,0.14)+0.8*motes(p+3.7,10.0,vec2(0.05,-0.08),t,0.07);',
    '    col+=mix(uGold,vec3(1.0),0.4)*m*(0.05+beam*3.2);',
    '  }else{',
    '    vec2 src=vec2(pt.x*0.12,-0.64);vec2 d=p-src;',
    '    float flick=0.86+0.07*sin(t*7.3)+0.05*sin(t*13.1+1.7)+0.06*noise(vec2(t*2.6,1.0));',
    '    float haze=fbm(p*2.1+vec2(0.0,-t*0.05));',
    '    float glow=exp(-length(d*vec2(0.85,1.2))*2.1)*flick;',
    '    col+=uGold*glow*(0.62+0.35*haze);',
    '    col+=uBlood*0.62*exp(-length(d*vec2(0.62,1.0))*1.35)*(0.7+0.3*haze);',
    '    float e=motes(p,16.0,vec2(0.02,0.22),t,0.10)+0.7*motes(p+5.3,8.0,vec2(-0.01,0.12),t,0.06);',
    '    col+=mix(uGold,vec3(1.0,0.72,0.42),0.45)*e*(0.18+glow*2.4);',
    '  }',
    '  float vig=1.0-smoothstep(0.15,1.25,length(vec2(p.x/aspect*1.25,p.y*1.1)));',
    '  col*=mix(0.42,1.0,vig);',
    '  col+=(hash(gl_FragCoord.xy+fract(t)*97.0)-0.5)/255.0;',
    '  gl_FragColor=vec4(mix(uInk,col,uFade),1.0);',
    '}'
  ].join('\n');

  function reducedMotion() {
    return Boolean(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }
  function cssColor(name, fallback) {
    var value = window.getComputedStyle(document.documentElement).getPropertyValue(name).trim();
    var parts = value.split(/[\s,]+/).map(Number).filter(function (number) { return !isNaN(number); });
    return (parts.length >= 3 ? parts.slice(0, 3) : fallback).map(function (channel) { return channel / 255; });
  }
  function compile(gl, type, source) {
    var shader = gl.createShader(type);
    if (!shader) return null;
    gl.shaderSource(shader, source);
    gl.compileShader(shader);
    if (gl.getShaderParameter(shader, gl.COMPILE_STATUS)) return shader;
    gl.deleteShader(shader);
    return null;
  }

  class OneVineLight extends HTMLElement {
    connectedCallback() {
      if (this._started) {
        if (this._gl) this._connect();
        return;
      }
      this._started = true;
      if (document.body && document.body.dataset.light === 'false') return;
      this._frame = null;
      try { this._initialize(); } catch (error) { this._fallback(); }
    }

    _initialize() {
      var canvas = document.createElement('canvas');
      this._canvas = canvas;
      // alpha: true although every pixel is opaque, so Windows never takes the canvas as an overlay
      // (some drivers then scramble the band under the header).
      var gl = canvas.getContext('webgl', { alpha: true, antialias: false, depth: false, stencil: false, premultipliedAlpha: false, powerPreference: 'low-power' });
      if (!gl) { this._fallback(); return; }
      this._gl = gl;
      var vertex = compile(gl, gl.VERTEX_SHADER, VERTEX);
      var fragment = compile(gl, gl.FRAGMENT_SHADER, FRAGMENT);
      if (!vertex || !fragment) {
        if (vertex) gl.deleteShader(vertex);
        if (fragment) gl.deleteShader(fragment);
        this._fallback();
        return;
      }
      var program = gl.createProgram();
      if (!program) { this._fallback(); return; }
      this._program = program;
      gl.attachShader(program, vertex);
      gl.attachShader(program, fragment);
      gl.linkProgram(program);
      gl.deleteShader(vertex);
      gl.deleteShader(fragment);
      if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
        this._fallback();
        return;
      }
      gl.useProgram(program);
      var buffer = gl.createBuffer();
      if (!buffer) { this._fallback(); return; }
      this._buffer = buffer;
      gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
      gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 3, -1, -1, 3]), gl.STATIC_DRAW);
      var position = gl.getAttribLocation(program, 'a');
      gl.enableVertexAttribArray(position);
      gl.vertexAttribPointer(position, 2, gl.FLOAT, false, 0, 0);

      canvas.setAttribute('aria-hidden', 'true');
      this.appendChild(canvas);
      this._onContextLost = this._fallback.bind(this);
      canvas.addEventListener('webglcontextlost', this._onContextLost);
      this._u = {};
      ['uRes', 'uTime', 'uPointer', 'uMode', 'uFade', 'uGold', 'uBlood', 'uInk'].forEach(function (name) {
        this._u[name] = gl.getUniformLocation(program, name);
      }, this);
      gl.uniform1f(this._u.uMode, this.dataset.mode === 'candle' ? 1 : 0);
      gl.uniform3fv(this._u.uGold, cssColor('--ov-gold-rgb', [198, 161, 91]));
      gl.uniform3fv(this._u.uBlood, cssColor('--ov-blood-rgb', [122, 23, 18]));
      gl.uniform3fv(this._u.uInk, cssColor('--ov-ink-rgb', [11, 10, 9]));

      // Pixels drawn per frame, whatever the screen size.
      this._budget = window.matchMedia('(max-width: 989px)').matches ? 150000 : 300000;
      this._pointer = { x: 0.5, y: 0.5, tx: 0.5, ty: 0.5 };
      this._box = null;
      this._frame = null;
      this._visible = false;
      this._slow = 0;
      this._last = 0;
      this._drawn = 0;
      this._born = 0;
      // The opening title covers the hero for ~1.3 s; let the light rise after it.
      this._delay = document.documentElement.classList.contains('ov-intro-on') ? 1300 : 0;
      this._tick = this._tick.bind(this);
      this._resize = this._resize.bind(this);
      this._onPointer = this._onPointer.bind(this);
      this._onEnter = this._onEnter.bind(this);
      this._onVisibility = this._onVisibility.bind(this);
      this._onMotion = this._onMotion.bind(this);
      this._motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this._connect();
    }

    _connect() {
      if (this._connected || this._failed || !this._healthy()) return;
      this._connected = true;
      if ('ResizeObserver' in window) {
        if (!this._resizeObserver) this._resizeObserver = new ResizeObserver(this._resize);
        this._resizeObserver.observe(this);
      } else {
        window.addEventListener('resize', this._resize, { passive: true });
      }
      this._resize();
      if (this._failed) return;
      var host = this.parentElement;
      if (host && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        host.addEventListener('pointerenter', this._onEnter, { passive: true });
        host.addEventListener('pointermove', this._onPointer, { passive: true });
        this._host = host;
      }
      document.addEventListener('visibilitychange', this._onVisibility);
      if (this._motionQuery.addEventListener) this._motionQuery.addEventListener('change', this._onMotion);
      else if (this._motionQuery.addListener) this._motionQuery.addListener(this._onMotion);
      this._onMotion();
      this._watch();
    }

    disconnectedCallback() {
      this._disconnect();
    }

    _disconnect() {
      this._stop();
      this._connected = false;
      this._visible = false;
      if (this._intersection) this._intersection.disconnect();
      this._intersection = null;
      if (this._resizeObserver) this._resizeObserver.disconnect();
      window.removeEventListener('resize', this._resize);
      if (this._host) {
        this._host.removeEventListener('pointerenter', this._onEnter);
        this._host.removeEventListener('pointermove', this._onPointer);
      }
      this._host = null;
      this._box = null;
      if (this._onVisibility) document.removeEventListener('visibilitychange', this._onVisibility);
      if (this._motionQuery) {
        if (this._motionQuery.removeEventListener) this._motionQuery.removeEventListener('change', this._onMotion);
        else if (this._motionQuery.removeListener) this._motionQuery.removeListener(this._onMotion);
      }
    }

    // A lost or invalid graphics surface must never cover the CSS backdrop.
    // Keep this element on its static fallback for the rest of its lifetime.
    _fallback() {
      if (this._failed) return;
      this._failed = true;
      this._disconnect();
      this._live = false;
      this.classList.remove('is-live');
      if (this._canvas) {
        if (this._onContextLost) this._canvas.removeEventListener('webglcontextlost', this._onContextLost);
        this._canvas.remove();
      }
      var gl = this._gl;
      try {
        if (gl && !(gl.isContextLost && gl.isContextLost() === true)) {
          if (this._buffer) gl.deleteBuffer(this._buffer);
          if (this._program) gl.deleteProgram(this._program);
        }
      } catch (error) { /* The static backdrop does not depend on GPU cleanup. */ }
      this._canvas = null;
      this._gl = null;
      this._buffer = null;
      this._program = null;
    }

    _healthy(checkErrors) {
      if (this._failed || !this._gl) return false;
      try {
        if (this._gl.isContextLost && this._gl.isContextLost() === true) {
          this._fallback();
          return false;
        }
        var error = checkErrors !== false && this._gl.getError ? this._gl.getError() : 0;
        if (typeof error === 'number' && error !== 0) {
          this._fallback();
          return false;
        }
        return true;
      } catch (error) {
        this._fallback();
        return false;
      }
    }

    _watch() {
      if (!this._gl || this._intersection) return;
      if (!('IntersectionObserver' in window)) {
        this._visible = true;
        this._start();
        return;
      }
      var self = this;
      this._intersection = new IntersectionObserver(function (entries) {
        if (!self._connected || self._failed) return;
        self._visible = entries[entries.length - 1].isIntersecting;
        if (self._visible) self._start(); else self._stop();
      }, { rootMargin: '120px 0px' });
      this._intersection.observe(this);
    }

    _resize() {
      if (!this._canvas || !this._healthy(false)) return;
      var area = Math.max(1, this.clientWidth * this.clientHeight);
      var ratio = Math.min(1, Math.sqrt(this._budget / area));
      var width = Math.max(2, Math.round(this.clientWidth * ratio));
      var height = Math.max(2, Math.round(this.clientHeight * ratio));
      if (this._canvas.width !== width || this._canvas.height !== height) {
        this._canvas.width = width;
        this._canvas.height = height;
        try {
          this._gl.viewport(0, 0, width, height);
          this._gl.uniform2f(this._u.uRes, width, height);
          if (!this._healthy()) return;
          if (this._still) this._draw(12, 1);
        } catch (error) { this._fallback(); }
      }
    }

    // The box is read once when the pointer enters; moves then use page
    // coordinates against it, so they never read layout.
    _onEnter() {
      var rect = this.getBoundingClientRect();
      this._box = { left: rect.left + (window.scrollX || 0), top: rect.top + (window.scrollY || 0), width: rect.width || 1, height: rect.height || 1 };
    }

    _onPointer(event) {
      if (!this._box) return;
      this._pointer.tx = (event.pageX - this._box.left) / this._box.width;
      this._pointer.ty = 1 - (event.pageY - this._box.top) / this._box.height;
    }

    _onVisibility() {
      if (document.hidden) this._stop();
      else if (this._visible) this._start();
    }

    _onMotion() {
      if (this._failed) return;
      this._still = this._motionQuery.matches;
      if (this._still) {
        this._stop();
        if (this._draw(12, 1)) this.classList.add('is-live');
      } else if (this._visible) this._start();
    }

    _start() {
      if (!this._connected || this._failed || this._still || this._frame !== null || document.hidden) return;
      this._last = 0;
      this._frame = window.requestAnimationFrame(this._tick);
    }

    _stop() {
      if (this._frame !== null) window.cancelAnimationFrame(this._frame);
      this._frame = null;
    }

    _draw(time, fade) {
      if (!this._connected || !this._healthy(false)) return false;
      var gl = this._gl;
      try {
        gl.uniform1f(this._u.uTime, time);
        gl.uniform1f(this._u.uFade, fade);
        gl.uniform2f(this._u.uPointer, this._pointer.x, this._pointer.y);
        gl.drawArrays(gl.TRIANGLES, 0, 3);
        return this._healthy();
      } catch (error) {
        this._fallback();
        return false;
      }
    }

    _tick(now) {
      if (!this._connected || this._failed || this._still || !this._visible || document.hidden) {
        this._stop();
        return;
      }
      this._frame = window.requestAnimationFrame(this._tick);
      if (!this._born) this._born = now;
      var age = now - this._born - this._delay;
      if (age < 0) return;
      // If frames keep arriving late, render fewer pixels.
      if (this._last) {
        var delta = now - this._last;
        this._slow = delta > 26 ? this._slow + 1 : Math.max(0, this._slow - 1);
        if (this._slow > 40 && this._budget > 60000) {
          this._budget *= 0.7;
          this._slow = 0;
          this._resize();
        }
      }
      this._last = now;
      // Thirty frames a second is plenty for drifting light.
      if (now - this._drawn < 31) return;
      this._drawn = now;
      this._pointer.x += (this._pointer.tx - this._pointer.x) * 0.08;
      this._pointer.y += (this._pointer.ty - this._pointer.y) * 0.08;
      var fade = Math.min(1, age / 1600);
      if (!this._draw(age / 1000 + 8, fade * fade * (3 - 2 * fade))) return;
      if (!this._live) {
        this._live = true;
        this.classList.add('is-live');
      }
    }
  }

  customElements.define('onevine-light', OneVineLight);
})();
